import { defineComponent as _defineComponent } from 'vue'
import AppModal from '@/v2/components/ui/AppModal.vue'
import AppButtonIcon from '@/v2/components/ui/button/AppButtonIcon.vue'
import AppIcon from '@/v2/components/ui/icon/AppIcon.vue'
import { useToggle } from '@vueuse/core'
import { LabelDialog } from './_types'
import { ModalContent, ModalFooter, ModalHeader, ModalRoot } from '@/v2/components/ui/modal'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLabel',
  props: {
  dialog: null,
  required: { type: Boolean }
},
  setup(__props) {

const props = __props;



const [dialogOpened, toggleDialog] = useToggle(false)

return { __sfc: true,props, dialogOpened, toggleDialog, AppButtonIcon, AppIcon, ModalContent, ModalHeader, ModalRoot }
}

})